var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('InstagramFeed',{attrs:{"title":"Lil' Spoonfuls","descripton":"Serving healthy, vegetarian eats to our kiddo, one bite at a time."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }